import { render, staticRenderFns } from "./_chapterId.vue?vue&type=template&id=ba183966&scoped=true&"
import script from "./_chapterId.vue?vue&type=script&lang=js&"
export * from "./_chapterId.vue?vue&type=script&lang=js&"
import style0 from "./_chapterId.vue?vue&type=style&index=0&id=ba183966&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba183966",
  null
  
)

export default component.exports